import { useTranslation } from 'react-i18next';
import Text from '../../components/Text/Text';
import Currency from '../../components/Currency/Currency';
import { Row } from '../../components/Grid/Grid';
import useCart from '../Cart/useCart';
import { VerticalSpacedList } from '../../components/Spaced/Spaced';

export function Total({ textType }: TotalProps) {
  const { t } = useTranslation();
  const { total } = useCart();

  return (
    <Row justifyContent="space-between">
      <Text type={textType}>{t('total')}</Text>
      <Currency textType={textType} value={total} />
    </Row>
  );
}

export function Subtotal() {
  const { t } = useTranslation();
  const { total, subtotal } = useCart();

  return total !== subtotal ? (
    <Row justifyContent="space-between">
      <Text>{t('subtotal')}</Text>
      <Currency value={subtotal} />
    </Row>
  ) : null;
}

function Discount({ name, amount }: DiscountProps) {
  return (
    <Row justifyContent="space-between">
      <Text type="primary">{name}</Text>
      <Currency textType="primary" value={amount} negative />
    </Row>
  );
}

export function Discounts() {
  const { discounts } = useCart();

  return (
    <VerticalSpacedList size="smaller">
      {discounts.map((discount) => (
        <Discount amount={discount.amount} name={discount.name} key={discount.name} />
      ))}
    </VerticalSpacedList>
  );
}
